
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleetShowersDayColour as ObiSleetShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleet-showers-day-colour.js';
 
 
 

 
 export const ObiSleetShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-sleet-showers-day-colour',
   elementClass: ObiSleetShowersDayColourElement,
   events: {
     
   }
  });
 
 